<div class="page-wrapper homepage">
  <div class="homepage-inner">
    <div class="wrap-message">
      <h2 class="text-center font-bold">
        Bienvenue {{ nameUser }} sur PIA V2
      </h2>
    </div>
    <div class="main-content-homepage py-5">
      <div class="container">
        <form *ngIf="userService.hasExtranetAccess('menu', 'catalogues', true)" [formGroup]="formFilterProduct">
          <div class="product-search">
            <h3 class="title text-center">RECHERCHER UN PRODUIT</h3>
            <div class="wrap-simplified row">
              <div class="col-xl-3 col-lg-3 col-md-6 px-2">
                <div class="wrap-select">
                  <label for="">Catégorie</label>
                  <p-dropdown formControlName="categoryProduct" class="w-12" [options]="listCategories"
                  (onChange)="onChangeCategories($event)"
                    optionLabel="nameCategory" placeholder="Choisissez une catégorie"></p-dropdown>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-6 px-2">
                <div class="wrap-select">
                  <label for="">Fournisseur</label>
                  <p-multiSelect
                  formControlName="fournisseur"
                  [options]="listSuppliers"
                  optionLabel="companyName"
                  placeholder="Choisissez un ou des fournisseurs"
                  optionValue="code"
              >
                  <ng-template pTemplate="empty">
                      <div *ngIf="loadingSuplier" class="overlay-loading">
                          <p-progressSpinner
                              styleClass="w-4rem h-4rem"
                              strokeWidth="8"
                              fill="var(--surface-ground)"
                              animationDuration=".5s"
                        ></p-progressSpinner>
                      </div>
                      <div *ngIf="!loadingSuplier">
                          <p>Aucune option disponible</p>
                      </div>
                  </ng-template>
                </p-multiSelect>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 px-2">
                <div class="wrap-input">
                  <label for="">Recherche</label>
                  <input (focusout)="emptyList()" (keyup)="onSearchInput()" formControlName="referenceProduct"
                    type="text" placeholder="Recherche globale sur le catalogue" />
                  <div class="autocomplete-list" *ngIf="autocompleteSearchlistProducts.length > 0">
                    <ul class="p-0" style="list-style: none">
                      <li class="ac-li" *ngFor="let item of autocompleteSearchlistProducts" (click)="selectItem(item)">
                        {{item.referenceProduct}}{{item.longDescription ? (item.uniqueId + ' - ' +
                        item.supplierItemNumber + ' - ' + item.longDescription + (item.brand ? ' - ' + item.brand : '')
                        ) : ''}}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div [ngClass]="{ active: isAdvancedActive }" class="wrap-advanced row">
              <!-- <div class="col-xl-6 col-lg-6 col-md-12 px-2">
                <div class="wrap-input">
                  <label for="">Marque</label>
                  <input formControlName="brand" type="text" placeholder="Choisissez une ou des marques" />
                </div>
              </div> -->
              <div class="col-xl-4 col-lg-4 col-md-6 px-2">
                <div class="wrap-select">
                  <label for="">Pays de fabrication</label>
                  <p-dropdown formControlName="countryOfManufacture" class="w-12" [options]="listCountries"
                    optionLabel="label" optionValue="valeur"
                    placeholder="Choisissez le pays de fabrication"></p-dropdown>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-6 px-2">
                <div class="wrap-select">
                  <label for="">Développement durable</label>
                  <p-multiSelect formControlName="developpementDurable" [options]="listSustainableDevelopment"
                    optionLabel="label" [filter]="false" placeholder="Choisissez un label"></p-multiSelect>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-12 px-2">
                <div class="wrap-select">
                  <label for="">Autres informations</label>
                  <p-multiSelect formControlName="autresInformations" [options]="listAutresInformations"
                    optionLabel="label" [filter]="false" placeholder="Choisissez un critère"></p-multiSelect>
                </div>
              </div>
            </div>

            <div class="group-btn text-center">
              <button (click)="submitSearch()" class="btn-common btn-rechercher">RECHERCHER</button>
              <button (click)="toggleAdvanced()" class="btn-move">
                <span *ngIf="isAdvancedActive">Recherche simple</span>
                <span *ngIf="!isAdvancedActive">Recherche avancée</span>
                <i [className]="
                                    isAdvancedActive
                                        ? 'pi pi-chevron-up ml-2 fs-5'
                                        : 'pi pi-chevron-down ml-2 fs-5'
                                "></i>
              </button>
            </div>
          </div>
        </form>

        <div [ngClass]="{'supplier-role': roleUser == '[Extranet - Fournisseur]'}" class="news-carousel">
          <h3 class="title text-center">ACTUALITÉS</h3>
          <div *ngIf="userService.hasExtranetAccess('menu', 'fournisseurs', true)" class="px-80">
            <div class="wrap-select">
              <label for="">Fournisseur</label>
              <p-multiSelect [options]="listSuppliers" optionLabel="companyName" optionValue="code"
                placeholder="Choisissez un ou des fournisseurs" (onChange)="onSuppliersChange($event)"></p-multiSelect>
            </div>
          </div>
          <div class="mt-4 px-80 wrap-carousel relative">
            <p-carousel *ngIf="listNews?.length" [value]="listNews" [numVisible]="4" [numScroll]="4" [circular]="false"
              [responsiveOptions]="responsiveOptions">
              <ng-template let-news pTemplate="item">
                <div (click)="showDialog(news)" class="item-news">
                  <div class="w-100" class="wrap-img mb-1">
                    <img class="w-100"
                      src="{{news?.photo?.[0]?.url ? news?.photo?.[0]?.url : '/src-adisco/assets/images/image-default.jpeg' }}"
                      alt="news-list-photo">
                  </div>
                  <p class="supplier mb-0">
                    {{ news?.supplierNameHomePage }}
                  </p>
                  <p *ngIf="news?.subject" class="title-news font-bold mb-2">{{news?.subject ?
                    news?.subject : ''}}
                  </p>
                  <p class="desc mb-1" *ngIf="news.description" [innerHTML]="news.description"></p>
                  <a href="#">En savoir plus</a>
                </div>
              </ng-template>
            </p-carousel>
            <div class="loading" *ngIf="loadingStatus">
              <img src="/src-adisco/assets/images/icon/loading.gif" alt="">
            </div>

            <div *ngIf="!listNews?.length && isSupplierState" class="empty-text">Aucune actualité publiée. <br>Si vous souhaitez communiquer
              auprès de nos adhérents, vous pouvez contacter : <a href="{{'mailto:'+emailContact}}">{{emailContact}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog [header]="newsDetail?.supplierName ? newsDetail?.supplierName : ''" [modal]="true" [(visible)]="visible"
  [style]="{ width: '1100px', 'min-height': '16rem' }">
  <div class="loading" *ngIf="isLoadingNewsDetail">
    <img src="/src-adisco/assets/images/icon/loading.gif" alt="">
  </div>
  <div class="popup-news" *ngIf="!isLoadingNewsDetail">
    <p class="title-news font-bold"> {{newsDetail?.subject}}</p>
    <div class="d-flex" style="max-height: 678px;">
      <div class="d-flex wrap-img w-50">
        <img
          [src]="newsDetail?.photo?.[0]?.url ? newsDetail?.photo?.[0]?.url : '/src-adisco/assets/images/image-default.jpeg'"
          alt="news-detail-photo">
        <div class="wrap-anchor d-flex align-items-center gap-3">
          <div *ngIf="newsDetail?.file" class="wrap-file w-6 p-2">
            <a class="d-flex align-items-center gap-3" href="#" (click)="onDownload($event)" target="_blank">
              <img src="src-adisco/assets/images/icon/file-text.png" alt="file-icon" />
              <div class="wrap-text">
                <p class="mb-0 font-bold">{{newsDetail?.file?.title}}</p>
                <p class="mb-0">{{newsDetail?.file?.file?.[0]?.name}}</p>
              </div>
            </a>
          </div>
          <a *ngIf="newsDetail?.externalLink" class="a-link w-6" [href]="newsDetail?.externalLink" target="_blank">Lien hypertexte</a>
        </div>
      </div>
      <div *ngIf="newsDetail?.summary" class="wrap-content w-50">
        <p [innerHTML]="newsDetail?.summary"></p>
      </div>
    </div>
  </div>
</p-dialog>